import ApiProject from "../../../../../../core/gd/api/project"
import asyncSessionLoader from "../../../../../../core/gd/data/async-session-loader"

type APICallParams = {
    company         : ID
    parentProject?  : ID
    name            : string
    owner?          : string
    color?          : number
    projectIcon?    : string
}

const debug = false
// const debug = 'quickAdd_createWhiteboard'

export default async function quickAdd_createWhiteboard(params: APICallParams) {

    await asyncSessionLoader(gd.session.findMissing({
        // @ts-ignore
        projectsSettings: [params.parentProject, ...gd.session.projects.getAllParentsIds(params.parentProject)]
    }))

    // create project for Page
    const data = await ApiProject.newWhiteboard({
        parentProjectId : params.parentProject,
        name            : params.name,
        color           : params.color,
        // isTemplate      : false,
        projectIcon     : params.projectIcon
    }).promise()

    const project = gd.session.projects.get(data.projectId)!
    debug && console.log(debug, 'onSubmit project', project.settings)

    return project
}
